export var initStateMemberData = {
    customerID: "",
    customerCode: "",
    customerName: "-",
    customerNameShort: "-",
    branchCode: "",
    branchName: "",
    address: "-",
    phoneNumber: "-"
};
